export const otpProviders = ["WA", "EMAIL"] as const;
